var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"filters-list"},_vm._l((_vm.availableFilters),function(filter,index){return _c('li',{key:index,staticClass:"filters-list__item"},[_c('button',{staticClass:"filters-list__btn",class:{ 'filters-list__btn--is-active': _vm.isFilterActive(filter) },on:{"click":function($event){_vm.toggleFilter(filter)}}},[_vm._v("\n      "+_vm._s(filter)+"\n    ")])])}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0c9c30a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Settings/FiltersList.vue
// module id = null
// module chunks = 